import { render } from "./AppFooterNav.vue?vue&type=template&id=151c8d72&scoped=true&ts=true"
import script from "./AppFooterNav.vue?vue&type=script&lang=ts"
export * from "./AppFooterNav.vue?vue&type=script&lang=ts"

import "./AppFooterNav.vue?vue&type=style&index=0&id=151c8d72&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151c8d72"]])

export default __exports__